import axios from "axios";

export const downloadSignedDTS = async (
  msd_compound: string,
  protocol_number: string,
  dts_version: string,
  transfer_id: string,
  supplier_org: string,
  created_time: string,
  is_signed_copy: boolean,
) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_PROXY_URL}/v1/downloadSignedDts`,
      {
        msd_compound,
        protocol_number,
        dts_version,
        transfer_id,
        supplier_org,
        created_time,
        is_signed_copy,
      },
      {
        headers: {
          Authorization: "Basic " + process.env.REACT_APP_AUTHORIZATION_KEY,
          "x-merck-apikey": process.env.REACT_APP_X_MERCK_API_KEY,
        },
      },
    );

    return response?.data?.downloadUrl;
  } catch (err: any) {
    if (err.response) {
      throw new Error(err.response.data.message);
    } else {
      throw new Error("An unexpected error occurred");
    }
  }
};
